import config from '@/config'

export default {
	id: 'SIMPLE_PAYWALL_4W_29_99_4W_17_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_29_99_4w_17_99_usd',
			EUR: 'simple_premium_4w_29_99_1w_17_99_eur',
			GBP: 'simple_premium_4w_29_99_4w_17_99_gbp',
			AUD: 'simple_premium_4w_49_99_4w_26_99_aud',
			CAD: 'simple_premium_4w_49_99_4w_26_99_cad',
			DKK: 'simple_premium_4w_259_4w_129_dkk',
			SEK: 'simple_premium_4w_399_4w_199_sek',
			NOK: 'simple_premium_4w_399_4w_199_nok',
			BRL: 'simple_premium_4w_99_4w_39_brl',
			MXN: 'simple_premium_4w_499_4w_229_mxn',
			TRY: 'simple_premium_4w_999_4w_599_try',
			ARS: 'simple_premium_4w_39990_4w_23990_ars',
			COP: 'simple_premium_4w_119990_4w_72890_cop',
			CLP: 'simple_premium_4w_29990_4w_17490_clp',
		},
		primer: 'prd_rBTU873XJMb4',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 28,
		priceMap: {
			USD: 17.99,
			EUR: 17.99,
			GBP: 17.99,
			AUD: 26.99,
			CAD: 26.99,
			DKK: 129,
			SEK: 199,
			NOK: 199,
			BRL: 39,
			MXN: 299,
			TRY: 599,
			ARS: 23990,
			COP: 72890,
			CLP: 17490,
		},
		originalPriceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 49.99,
			CAD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 99,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 49.99,
			CAD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 99,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
}
